import * as React from "react";

const DashboardPage = React.lazy(() => import("./Dashboard"));

const routePrefix = "/chat/dashboard";

export const DashboardRoutes = [
  {
    id: "CHAT_DASHBOARD",
    path: `${routePrefix}`,
    layoutId: "MainLayout",
    component: DashboardPage,
    navigation: {
      section: "chat",
      navGroup: "Chat",
      navTitle: "Dashboard / Search",
    },
  },
];
